import PropTypes from 'prop-types';

import ArticleCard from './ArticleCard';
import CustomHeading from './CustomHeading';

import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { getBlogImageSrc } from '@/utils/blogUtils';
import styles from './ArticleCardList.module.scss';
import { ARTICLE_CARD_TYPE, POSITION_TYPE } from '@/constants/blog';

export const ArticleCardList = ({
  title, description, customization, articleCardType, articles, tagOrArchive = false
}) => {
  const { headingLevel, position, customClassName } = customization;
  const { isMobile } = useScreenSizeContext();
  const sectionClassName = [
    customClassName?.['articleCardList'],
  ].filter(Boolean).join(' ');

  const imagesToLazyLoad = (index) => {
    if (isMobile) {
      return index > 0;
    }
    return tagOrArchive ? index > 2 : true;
  };

  return (
    <div className={`${styles['container']} ${sectionClassName}`} data-test-id="article-card-list-container" data-rbf="article-card-list-container">
      {(title || description) && (
        <div className={styles['title-container']}>
          {title && (
            <CustomHeading
              title={title}
              headingLevel={headingLevel.articleCardList}
              labelPosition={position.articleCardList}
              customClassName={{ label: styles['title'] }}
            />
          )}

          {description && (
            <p className={styles.description} data-test-id="section-description">
              {description}
            </p>
          )}
        </div>
      )}

      {articles.length > 0 && (
        <div className={`${styles['card-grid']} ${articleCardType === ARTICLE_CARD_TYPE.SMALL ? styles['card-grid-small'] : styles['card-grid-medium']} `}>
          {articles?.map((article, index) => {
            const { imageName, imageAlt, publishedAt, title, shortDesc, urlKeyword } = article.articles[0];
            return (
              <ArticleCard
                key={article.id}
                id={article.id}
                imageSrc={getBlogImageSrc(imageName, isMobile, articleCardType)}
                articleCardType={articleCardType}
                imageAlt={imageAlt}
                tags={article.tags}
                title={title}
                shortDesc={shortDesc}
                publishedAt={publishedAt}
                urlKeyword={urlKeyword}
                customization={{
                  headingLevel: headingLevel.articleCard
                }}
                isLazyLoaded={imagesToLazyLoad(index)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

ArticleCardList.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  customization: PropTypes.shape({
    headingLevel: PropTypes.shape({
      articleCardList: PropTypes.oneOf([1, 2, 3, 4, 5]),
      articleCard: PropTypes.oneOf([1, 2, 3, 4, 5]),
    }),
    position: PropTypes.shape({
      articleCardList: PropTypes.oneOf([POSITION_TYPE.CENTER, POSITION_TYPE.START]),
      articleCard: PropTypes.oneOf([POSITION_TYPE.CENTER, POSITION_TYPE.START]),
    }),
    customClassName: PropTypes.object,
  }),
  articleCardType: PropTypes.oneOf([ARTICLE_CARD_TYPE.SMALL, ARTICLE_CARD_TYPE.MEDIUM, ARTICLE_CARD_TYPE.LARGE]),
  articles: PropTypes.array,
  tagOrArchive: PropTypes.bool
};

export default ArticleCardList;
